<template>
  <div class="copy">
    <button type="button" @click="copyLink" class="copy-button">
      <Icon :iconName="iconName" iconColor="#788694" />
    </button>
  </div>
</template>
<script>
import Vue from 'vue';
import Clipboard from 'v-clipboard';
import Icon from '../Icon/Icon';
import { errorMsg } from '@/utils/mixins';

Vue.use(Clipboard);

export default {
  mixins: [errorMsg],
  props: {
    text: {
      type: String
    },
    iconName: {
      type: String,
      default: 'Copy'
    }
  },
  components: {
    Icon
  },
  methods: {
    copyLink() {
      try {
        this.$clipboard(this.text);
        this.showNotification({
          offset: 100,
          showClose: true,
          message: 'Успешно скопировано',
          duration: 6500,
          type: 'success'
        });
      } catch (err) {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: 'Ошибка копирования',
          duration: 6500,
          type: 'error'
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.copy {
  margin-left: auto;

  &-button {
    border: transparent;
    background: transparent;
  }
}
</style>
